<template>
    <b-container>
      <b-alert variant="success" :show="create" dismissible>Doc Created!</b-alert>
      <span class="float-right"><a href="/doc/create" class="btn btn-secondary">Create Doc</a></span>
        <h1>Documents</h1>
        <DocsList :list="docs" />
    </b-container>
</template>
<script>
import DocDataService from "@/services/DocDataService";
export default {
  props: ["company"],
  components: {
    DocsList: () => import("./DocsList.vue"),
  },
  data() {
    return {
      docs: [],
      create: false
    };
  },
  created() {

    console.log(this.$route.query.create)

    if (this.$route.query.create === 'success') {
      this.create = true
    }

    DocDataService.getAll()
      .then((response) => {
        this.docs = response.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
</script>